module.exports = __webpack_public_path__ + "static/media/nodata.00a0ce00.png";